import React, { useState } from 'react';
import { useAdditionalWorkflowAiService } from 'nekst-api';
import { ParseContractDataReactContext } from 'features/tasks-forms';
import { useDataLoaderNew } from 'data-loader';
import { LoadingAnimation } from 'ui-builder';

export default function AdditionalWorkflowParseContractDataProvider(props: {
  projectId: number;
  planId: number;
  children: React.ReactNode;
}) {
  const aiService = useAdditionalWorkflowAiService();

  const [selectedFields, setSelectedFields] = useState<Record<number, boolean>>({});

  const { data: parseResult } = useDataLoaderNew(
    () => aiService.getContractParseResult(props.projectId, props.planId),
    { dependencies: [props.projectId, props.planId] },
  );

  const isFieldSelected = (fieldId: number) => !!selectedFields[fieldId];

  const toggleFieldSelection = (fieldId: number) => {
    setSelectedFields((prev) => ({
      ...prev,
      [fieldId]: !prev[fieldId],
    }));
  };

  const getNumberOfSelectedFields = () =>
    Object.values(selectedFields).filter((v) => v).length;

  const removeContact = async (internalId: number) => {
    await aiService.removeContact(props.projectId, props.planId, internalId);
  };

  if (parseResult) {
    return (
      <ParseContractDataReactContext.Provider
        value={{
          parseResult,
          removeContact,
          isFieldSelected,
          toggleFieldSelection,
          getNumberOfSelectedFields,
        }}
      >
        {props.children}
      </ParseContractDataReactContext.Provider>
    );
  } else {
    return <LoadingAnimation />;
  }
}
